import { styled } from "@mui/material"

// @ts-ignore
import CirrusLogo from "../../../public/static/img/cr_logo_white.svg"

const Logo = styled("div")({
  background: `url('${CirrusLogo}') 50% 50% no-repeat`,
  backgroundSize: "cover",
  margin: "0 auto"
})

export const HeaderLogo = styled(Logo)({
  width: "136px",
  height: "28px",
})

export const FooterLogo = styled(Logo)({
  width: "50px",
  height: "10px",
})